import Http from "../http";

export const getQuestionElements = async ({
  questionId,
  jobId,
  file,
  allJobs,
}) => {
  const path = `/v2/blueprints`;
  const params = {
    file,
  };
  if (!allJobs) {
    params["job"] = jobId;
    params["question"] = questionId;
  }
  try {
    const response = await Http.sharedInstance.withAuth().get(path, {
      params: params,
    });
    return response.data;
  } catch (e) {
    return [];
  }
};

export const getMarkings = async (params) => {
  const path = `/v2/blueprints/markings`;
  try {
    const response = await Http.sharedInstance.withAuth().get(path, {
      params: params,
    });
    return response.data;
  } catch (e) {
    return [];
  }
};

export const updateElements = async ({
  question,
  job,
  file,
  elements,
  measurements,
}) => {
  if (!job) {
    throw new Error("Please supply job to updateElements http call");
  }
  const path = `/v2/blueprints/${job}/${question}`;
  const params = {
    question,
    file,
    job,
    measurements: { ...measurements },
    elements: elements.filter((el) => typeof el.elementId !== "undefined"),
  };
  try {
    const response = await Http.sharedInstance.withAuth().put(path, params);
    return response.data;
  } catch (e) {
    // SAM-257: `null`, not `[]`. blueprint.controller.ts's PUT returns the
    // service result raw with no `success` envelope, so truthiness is the only
    // check the callers can make — and `[]` passed it on every failure.
    return null;
  }
};

export const exportBlueprintPdf = async ({
  blueprintImage,
  elements,
  size,
}) => {
  // `POST /v2/jobs/blueprint/export` never existed — 7eb4e9254 flipped the path
  // from /v1/ to /v2/ without adding the v2 route, and nginx has since dropped
  // `^/(v1)/` entirely, so blueprint PDF export has been a silent 404 in
  // production. Points at the replacement route in api/src/blueprint/ (owned
  // there); body and `{ success, link }` reply are unchanged from the v1
  // handler (server/.../jobs_controller.js exportBlueprint).
  const path = `/v2/blueprints/export`;
  const params = { blueprintImage, elements, size };
  try {
    const response = await Http.sharedInstance.withAuth().post(path, params);
    return response.data;
  } catch (e) {
    // SAM-257: was `return []`. The v1 handler replies `{ success: true, link }`
    // (server/src/providers/jobs/controllers/jobs_controller.js exportBlueprint).
    return { success: false, link: null };
  }
};

export const deleteElement = async (id) => {
  const path = `/v2/blueprints/element/${id}`;
  try {
    const response = await Http.sharedInstance.withAuth().delete(path);
    return response.data;
  } catch (e) {
    return {
      success: false,
      error: e,
    };
  }
};

export const exportMarkingsXslx = async (params) => {
  const path = `/v2/blueprints/markings/export`;
  try {
    const response = await Http.sharedInstance.withAuth().post(path, params, {
      responseType: "blob", // Ensure response is a Blob (binary)
    });
    return response.data;
  } catch (e) {
    return {
      success: false,
      error: e,
    };
  }
};
